// utils/previewImage.js
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { Toast } from "vant";

export function previewImage(url) {
  // 创建一个隐藏的 img 容器
  const img = document.createElement("img");
  img.src = url;
  img.style.display = "none";
  document.body.appendChild(img);

  let viewer = null;

  const createDownloadButton = () => {
    const button = document.createElement("img");
    button.src =
      "https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/saveImageBtn.png";
    button.style.position = "absolute";
    button.style.bottom = "20px";
    button.style.left = "50%";
    button.style.width = "135px";
    button.style.height = "48px";
    button.style.transform = "translateX(-50%)";
    button.style.color = "#fff";
    button.style.zIndex = "1002";
    button.style.cursor = "pointer";

    button.addEventListener("click", () => {
      console.log("点击了下载按钮");
      window.open(viewer.image.src);
    });

    button.setAttribute("data-viewer-download-btn", "true");
    document.body.appendChild(button);
  };

  const removeDownloadButton = () => {
    const btn = document.querySelector("[data-viewer-download-btn]");
    if (btn) btn.remove();
  };

  viewer = new Viewer(img, {
    inline: false,
    navbar: false,
    title: false,
    toolbar: false,
    tooltip: false,
    scalable: false,
    transition: true,
    fullscreen: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    viewed() {
      // 点击图片即可关闭
      viewer.image.onclick = () => {
        viewer.hide();
      };
    },
    shown() {
      createDownloadButton();
    },
    hidden() {
      removeDownloadButton();
      viewer.destroy();
      img.remove();
    },
  });

  viewer.show();
}
